import React from 'react';
import { deckPages } from '../../data/deck';
interface DeckNavProps {
  active: string;
}

/** Quiet page rail for moving through the presentation. */
export function DeckNav({
  active
}: DeckNavProps) {
  const activeIndex = Math.max(0, deckPages.findIndex(page => page.id === active));
  const goTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <nav aria-label="Presentation pages" className="fixed right-5 top-1/2 z-40 hidden -translate-y-1/2 flex-col items-end gap-3 lg:flex" data-id="element-91" data-mp="1yacq0nwp210b">
      {deckPages.map((page, i) => {
      const isActive = i === activeIndex;
      return <button key={page.id} type="button" onClick={() => goTo(page.id)} aria-label={`Page ${i + 1}: ${page.label}`} aria-current={isActive ? 'true' : undefined} className="group flex items-center gap-3 focus:outline-none" data-id="element-92" data-mp="1je3rxpojhtph" data-mpi={i}>
            <span className="pointer-events-none whitespace-nowrap rounded-full bg-white px-3 py-1 font-body text-[10px] uppercase tracking-[0.16em] text-background opacity-0 shadow-sm ring-1 ring-[rgba(1,51,43,0.08)] transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100" data-id="element-93" data-mp="20tq1r5k3602c">
              {String(i + 1).padStart(2, '0')} · {page.label}
            </span>
            <span className={['block rounded-full transition-all duration-300 group-focus-visible:ring-2 group-focus-visible:ring-primary', isActive ? 'h-6 w-1.5 bg-background' : 'h-1.5 w-1.5 bg-[rgba(1,51,43,0.22)] group-hover:bg-[rgba(1,51,43,0.5)]'].join(' ')} data-id="element-94" data-mp="1i3rswn8gs2xn" />
          </button>;
    })}
      <span className="mt-2 font-body text-[10px] tabular-nums tracking-[0.12em] text-[rgba(1,51,43,0.4)]" data-id="element-95" data-mp="z446mb27w8ya">
        {String(activeIndex + 1).padStart(2, '0')}/{String(deckPages.length).padStart(2, '0')}
      </span>
    </nav>;
}